import type { SVGProps } from 'react';

/** Poland — horizontal white over red. Decorative (`aria-hidden`); see `GbFlag` for sizing/crop notes. */
export const PlFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 60 30"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}>
        <rect width="60" height="30" fill="#fff" />
        <rect y="15" width="60" height="15" fill="#DC143C" />
    </svg>
);
